import styled from 'styled-components';

export const Container = styled.div`
  z-index: 10000;
`;
